/* eslint-disable no-console */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('../../ServiceWorker.js', {scope: './'})
    .then(function (reg) {
      console.log('Service worker running')
    })
    .catch(function (err) {
      console.log(err)
    })
}



// WEBPACK FOOTER //
// ./src/registerServiceWorker.js